export const STATUS_CODE = {
  ok: 200,
  badRequest: 400,
  unauthorized: 401,
  internalServerError: 500
};
